import { render, staticRenderFns } from "./OrthoPainType.vue?vue&type=template&id=df21d6ae&scoped=true"
import script from "./OrthoPainType.vue?vue&type=script&lang=js"
export * from "./OrthoPainType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df21d6ae",
  null
  
)

export default component.exports